<template>
  <v-row>
    <div class="col-md-12 home-box">
      <Breadcrumbs :title="'Product Sales'"></Breadcrumbs>
      <ProductSalesReport></ProductSalesReport>
    </div>
    <div class="col-md-12 home-tabs-body"></div>
  </v-row>
</template>

<script>
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import ProductSalesReport from "@/components/reports/ProductSalesReport.vue";
export default {
  components: { Breadcrumbs, ProductSalesReport },
};
</script>
